import React from 'react';
import { BookOpen } from 'lucide-react';
const LoginInfo: React.FC = () => (
  <div className="left-panel">
    <span style={{ display: 'hidden' }}></span>
    <div className="left-panel-grid-bg"></div>
    <div className="left-panel-content">
      <div className="left-panel-header">
        <div className="left-panel-logo">
          <BookOpen size={24} color="black" />
        </div>
        <div>
          <h2 className="left-panel-title">MARCIAL PONS</h2>
          <span className="left-panel-version">ALBATROSS v0.1</span>
        </div>
      </div>
      <div className="left-panel-main">
        <h1 className="left-panel-heading">GESTIÓN <br /><span>INTELIGENTE</span> <br />EDITORIAL.</h1>
        <p className="left-panel-desc">Optimiza tu flujo logístico y editorial con la plataforma de control más avanzada del sector.</p>
      </div>
    </div>
    <div className="left-panel-stats">
      <div className="left-panel-stat-item">
        <span className="left-panel-stat-value">24/7</span>
        <span className="left-panel-stat-label">Monitorización</span>
      </div>
      <div className="left-panel-stat-item">
        <span className="left-panel-stat-value">100%</span>
        <span className="left-panel-stat-label">Integración</span>
      </div>
      <div className="left-panel-stat-item">
        <span className="left-panel-stat-value">AI</span>
        <span className="left-panel-stat-label">Asistida</span>
      </div>
    </div>
  </div>
);

export default LoginInfo;
